export function fromUTCtoLocalTime(utcTimestamp: number): number {
  const utc = new Date(utcTimestamp);

  return new Date(
    utc.getUTCFullYear(),
    utc.getUTCMonth(),
    utc.getUTCDate(),
    utc.getUTCHours(),
    utc.getUTCMinutes(),
    utc.getUTCSeconds(),
    utc.getUTCMilliseconds(),
  ).getTime();
}
